export default __webpack_public_path__ + "static/media/footer.28efe252.png";